/**
 * Non-destructive actions that are shared across all chart renderings.
 * Example: View Data from a vegas chart renderer context menu
 */

export enum SharedChartCommandActionType {
  ViewChartData = '[SharedChart] ViewChartData',
  ViewUnaggregatedChartData = '[SharedChart] ViewUnaggregatedChartData',
  CloseAllModals = '[SharedChart] CloseAllModals',
}
